<template  style="width: 1500px;">
  
  <a-spin switchFullscreen :spinning="confirmLoading"  style="width: 1500px;">
    <j-form-container :disabled="formDisabled"  style="width: 1500px;">
      <a-form :form="form" slot="detail" style="">
         
          
            <!-- <a-form-item label="医院名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['hosName']" placeholder="请输入医院名称"></a-input>
            </a-form-item>
          
          
            <a-form-item label="科室名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['departmentName']" placeholder="请输入科室名称"></a-input>
            </a-form-item>
           -->
          
            <a-form-item label="文章标题" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['title']" placeholder="请输入文章标题"></a-input>
            </a-form-item>

            <a-form-item label="封面图" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-image-upload isMultiple v-decorator="['thumbnail']"></j-image-upload>
            </a-form-item>
          
          
            <!-- <a-form-item label="封面图" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-image-upload isMultiple v-decorator="['picUrl']"></j-image-upload>
            </a-form-item> -->
          
          
            <a-form-item label="内容" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <div style="border: 1px solid #ccc">
                <Toolbar
                  style="border-bottom: 1px solid #ccc"
                  :editor="editor"
                  :default-config="toolbarConfig"
                  :mode="mode"
                />
                <Editor
                  style="height:510px; overflow-y: hidden;"
                  class="editor-container"
                  v-model="html"
                  :defaultConfig="editorConfig"
                  :mode="mode"
                  @onCreated="onCreated"
                />
               </div>
                
            </a-form-item>
          
            <a-form-item label="文章类型" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-select v-decorator="['type']" placeholder="请选择文章类型" :getPopupContainer= "(target) => target.parentNode">
                <a-select-option :value="'0'">仪器设备</a-select-option>
                <a-select-option :value="'1'">治疗疗法</a-select-option>
                <a-select-option :value="'2'">院内动态</a-select-option>
                <a-select-option :value="'3'">义诊活动</a-select-option>
                <a-select-option :value="'4'">大医中研</a-select-option>
              </a-select>
            </a-form-item>
          
          
            <a-form-item label="上架" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-switch v-decorator="['isUp']" ></j-switch>
            </a-form-item>
          
          <a-col v-if="showFlowSubmitButton"  style="text-align: center">
            <a-button @click="submitForm">提 交</a-button>
          </a-col>
          
         
      </a-form>
    </j-form-container>
  </a-spin>
</template>

<script>
  import Vue from 'vue'
  import { httpAction, getAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import JFormContainer from '@/components/jeecg/JFormContainer'
  import JImageUpload from '@/components/jeecg/JImageUpload'
  import JMultiSelectTag from "@/components/dict/JMultiSelectTag"
  import JEditor from '@/components/jeecg/JEditor'
  import JSwitch from '@/components/jeecg/JSwitch'
  import { Editor, Toolbar } from "@wangeditor/editor-for-vue";


  export default {
    name: 'WebsiteArticleForm',
    components: {
      JFormContainer,
      JImageUpload,
      JMultiSelectTag,
      JEditor,
      JSwitch,Editor, Toolbar 
    },
    props: {
      //流程表单data
      formData: {
        type: Object,
        default: ()=>{},
        required: false
      },
      //表单模式：true流程表单 false普通表单
      formBpm: {
        type: Boolean,
        default: false,
        required: false
      },
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        form: this.$form.createForm(this),
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
        },
        url: {
          add: "/zyWebsite/websiteArticle/add",
          edit: "/zyWebsite/websiteArticle/edit",
          queryById: "/zyWebsite/websiteArticle/queryById"
        },
        // 富文本框
        editor: null,
        html: '',
        editorConfig: {
          placeholder: '请输入内容...', // 所有的菜单配置，都要在 MENU_CONF 属性下
          MENU_CONF: {
            // uploadImage: {
            //   server: 'https://bjzyzyy.net/api/v1/uploadZy', // 图片上传接口
            //   fieldName: 'file',
            //   maxFileSize: 2 * 1024 * 1024, // 限制文件大小, 单位字节
            //   onSuccess: this.handleImageSuccess,
            //   onFailed: this.handleImageFailed
            //  // customUpload:this.uploadImg
            // },
            uploadImage: {
              // 上传服务器地址
              server: 'https://bx_manager.dyzh120.com/jeecg-boot/oss/file/uploadZy',
              // 上传表单字段名
              fieldName: 'file',
              // 最大文件大小限制（10MB）
              maxFileSize: 10 * 1024 * 1024,
              // 最多上传文件数量
              maxNumberOfFiles: 10,
              // 允许的文件类型
              allowedFileTypes: ['image/*'],
              // 自定义请求头
              headers: {
                Authorization: 'Bearer '
              },
              // 跨域配置
              withCredentials: false,
              // 超时时间
              timeout: 10 * 1000,
              // 自定义插入图片
              customInsert: (res, insertFn) => {
                // res 为后端返回结果
                // 根据后端返回格式获取图片URL
                insertFn(res.message)
              }
            },
            uploadVideo:{
              fieldName: 'file',
              server: 'https://bx_manager.dyzh120.com/jeecg-boot/oss/file/uploadZy',
              // 单个文件的最大体积限制，默认为 400M
              maxFileSize: 400 * 1024 * 1024,
              // 最多可上传几个文件，默认为 5
              maxNumberOfFiles: 3,
              // 选择文件时的类型限制，默认为 ['video/*'] 。如不想限制，则设置为 []
              allowedFileTypes: ['video/*'],
              metaWithUrl: false,
              // 自定义增加 http  header
              headers: {
                Authorization: 'Bearer '
              },
              // 超时时间，默认为 30 秒
              timeout: 1000 * 1000, // 1000 秒,
              // 上传之前触发
              onBeforeUpload(file) {
                console.log('视频正在上传中');
                return file;
              },
              // 自定义插入视频
              customInsert(res, insertFn) {
                // 因为自定义插入导致onSuccess与onFailed回调函数不起作用,自己手动处理
                // 先关闭等待的Message
                console.log('-------------------',res)
                // ElMessage.closeAll();
                // if (res.code === 1) {
                //   ElMessage.success({
                //     message: `${res.data.name} 上传成功`
                //   });
                // } else {
                //   ElMessage.error({
                //     message: `${res.data.name} 上传失败，请重新尝试`
                //   });
                // }
                insertFn(res.message);
              }
            }
          },
        },
        mode: 'default', // or 'simple'
        toolbarConfig: {}
      }
    },
    computed: {
      formDisabled(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return false
          }
          return true
        }
        return this.disabled
      },
      showFlowSubmitButton(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return true
          }
        }
        return false
      }
    },
    created () {
      this.onCreated()
      this.showFlowData();
    },
    methods: {
      onCreated(editor) {
        this.editor = Object.seal(editor); // 一定要用 Object.seal() ，否则会报错
      },
      add () {
        this.html=''
        this.edit({});
      },
      edit(record) {
        setTimeout(() => {
          if(record.content) {
            this.html = record.content
          }
         },500);
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'hosId','departmentId','hosName','departmentName','title','thumbnail','picUrl','content','type','typeName','isUp','isUpName'))
        })
      },
      //渲染流程表单数据
      showFlowData(){
        if(this.formBpm === true){
          let params = {id:this.formData.dataId};
          getAction(this.url.queryById,params).then((res)=>{
            if(res.success){
              this.edit (res.result);
            }
          });
        }
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            if(this.model.content == '<p><br></p>' || this.model.content == null){
              alert('是否需要对上述文章内容进行修改？')
            }
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据",formData)
            formData.content = that.html
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }
         
        })
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'hosId','departmentId','hosName','departmentName','title','thumbnail','picUrl','content','type','typeName','isUp','isUpName'))
      },
    },
    // beforeDestroy() {
    //   if(this.editor) {
    //     this.editor.destroy();
    //     this.editor = null;
    //   }
    // }
  }
</script>
<style src="@wangeditor/editor/dist/css/style.css"></style>